var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIconAwesomeUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.166,
    height: 20.761,
    viewBox: "0 0 18.166 20.761",
    fill: "#cae7f1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user",
    "data-name": "Icon awesome-user",
    d: "M9.083,10.381a5.19,5.19,0,1,0-5.19-5.19A5.19,5.19,0,0,0,9.083,10.381Zm3.633,1.3h-.677a7.059,7.059,0,0,1-5.912,0H5.45A5.451,5.451,0,0,0,0,17.128v1.687a1.947,1.947,0,0,0,1.946,1.946H16.22a1.947,1.947,0,0,0,1.946-1.946V17.128A5.451,5.451,0,0,0,12.716,11.678Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconAwesomeUser);
export default __webpack_public_path__ + "static/media/Sidebar-Icon-awesome-user.e884a4bf89e5dcb2005f2f3c9b1f9d54.svg";
export { ForwardRef as ReactComponent };